<template>
  <div class="member-summary d-flex py-3 px-0">
    <div
      class="status-statistic d-flex flex-grow-1 px-2 justify-content-between"
    >
      <div class="">
        <span>{{ $t("unit.total") }}</span>
        <h6>{{ totalHome }}</h6>
      </div>
      <div class="">
        <span>{{ $t("feature.member.active") }}</span>
        <h6 class="active">{{ activeHome }}</h6>
      </div>
    </div>
    <div class="categories px-2 flex-grow-1">
      <div class="info">
        <span>{{ $t("owner.owner") }}</span>
        <span class="count">{{ totalOwner }}</span>
        <span>{{ $t("unit.people") }}</span>
      </div>
      <div class="info">
        <span>{{ $t("owner.resident") }}</span>
        <span class="count">{{ totalResident }}</span>
        <span>{{ $t("unit.people") }}</span>
      </div>
      <div class="info">
        <span>{{ $t("owner.renter") }}</span>
        <span class="count">{{ totalRenter }}</span>
        <span>{{ $t("unit.people") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    homes: {
      type: Array
    }
  },
  computed: {
    totalHome() {
      return this.homes.length;
    },
    activeHome() {
      return this.homes.filter(home => home.isActive).length;
    },
    totalOwner() {
      return this.homes.reduce((sum, home) => {
        let total = sum;
        total += home.roles.owner;
        return total;
      }, 0);
    },
    totalResident() {
      return this.homes.reduce((sum, home) => {
        let total = sum;
        total += home.roles.resident;
        return total;
      }, 0);
    },
    totalRenter() {
      return this.homes.reduce((sum, home) => {
        let total = sum;
        total += home.roles.renter;
        return total;
      }, 0);
    }
  }
};
</script>

<style lang="scss" scoped>
.member-summary {
  border-top: 1px solid #e0e0e0;
  span {
    color: #8c8786;
    font-size: 11px;
  }
}
.status-statistic {
  border-right: solid 1px #d8d6d9;
  h6 {
    font-size: 22px;
    font-weight: bold;
    &.active {
      color: #00b793;
    }
  }
}
.categories {
  .info {
    text-align: right;
  }
  .count {
    color: black;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/member/HomeSummary.vue